import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface RestoreResponse {
    success: boolean;
    message: string;
}

type ReturnType = Promise<AxiosResponse<RestoreResponse>>;

const restoreTrackEvent = (uuid: string): ReturnType => {
    return Request.post(`/workouts/track-events/${uuid}/restore`);
};

export default restoreTrackEvent;
